import styled from 'styled-components';

export const Warning = styled.p`
  font-size: 13px;
  line-height: 20px;
  font-weight: 500;
  span {
    color: red;
  }
`;
